<div class="comparison-grid expanded-mode"
     data-test="policy-comparison-grid"
     [formGroup]="form()"
>
  <!-- External Data Source Origami -->
  <div data-test="external-datasource-placeholder">
  </div>
  <div class="override-cell"
       data-test="override-datasource-cell"
  >
    <albert-select controlName="uuid"
                   inputId="ovr_policy"
                   label="Applicable Proposal / Policy"
                   [attr.data-test]="'override-datasource-select'"
                   [editable]="false"
                   [options]="policyOptions() ?? []"
    />
  </div>

  <!-- External coverageType -->
  <div data-test="external-coverageType-cell"
       formGroupName="coverageType"
  >
    <albert-select class="origami-field"
                   controlName="externalValue"
                   data-test="external-coverageType"
                   groupName="coverageType"
                   inputId="ext_coverageType"
                   label="Coverage Type"
                   optionLabel="label"
                   optionValue="value"
                   [disabled]="true"
                   [options]="coverageTypeOptions"
    />
  </div>
  <!-- Local coverageType -->
  <div class="override-cell"
       data-test="override-coverageType-cell"
       formGroupName="coverageType"
  >
    <albert-select controlName="localValue"
                   groupName="coverageType"
                   inputId="ovr_coverageType"
                   label="Coverage Type"
                   optionLabel="label"
                   optionValue="value"
                   [attr.data-test]="'override-coverageType'"
                   [disabled]="true"
                   [options]="coverageTypeOptions"
    />
  </div>
</div>
